// เหตุการณ์เฉพาะตัวของสัตว์ไม่มีกระดูกสันหลังที่มีชื่อเสียง (ดู signature.ts)

import type { GameEvent } from "../../engine/types";
import { sig } from "./signature";

const ADULT = ["adult", "old"] as const;

export const SIGNATURE_INVERTEBRATE_EVENTS: readonly GameEvent[] = [
  // ---------- แมลง ----------
  sig("Xylotrupes gideon", "rhino_beetle_fight", {
    stageTags: ADULT,
    text: "เด็กๆ จับคุณมาวางบนท่อนอ้อย อีกฝั่งมีด้วงกว่างตัวผู้อีกตัว และมีตัวเมียผูกไว้ตรงกลาง",
    fact: "ชาวบ้านภาคเหนือนำด้วงกว่างตัวผู้มาชนกันบนท่อนอ้อยเป็นการละเล่นพื้นบ้าน โดยใช้ตัวเมียล่อให้ตัวผู้สู้กัน",
    choices: [
      {
        label: "ใช้เขางัดคู่ต่อสู้",
        outcomes: [
          { chance: 0.6, text: "คุณงัดอีกตัวตกจากท่อนอ้อย เด็กๆ ปล่อยคุณกลับต้นไม้", effects: { safety: 10 } },
          { chance: 0.4, text: "คุณถูกงัดตกลงพื้น ขาหักไปข้างหนึ่ง", effects: { health: -25, cause: "human" } },
        ],
      },
      { label: "ไม่สู้ เดินหนี", outcomes: [{ chance: 1, text: "เด็กๆ เบื่อแล้วปล่อยคุณไป", effects: { fullness: -5 } }] },
    ],
  }),
  sig("Aedes aegypti", "mosquito_blood_meal", {
    stageTags: ADULT,
    text: "คุณเป็นยุงตัวเมียที่ต้องการเลือดเพื่อสร้างไข่ มีคนนั่งดูโทรทัศน์อยู่ในห้อง",
    fact: "ยุงลายตัวเมียเท่านั้นที่กัดดูดเลือด เพราะต้องใช้โปรตีนในเลือดสร้างไข่ ส่วนตัวผู้กินน้ำหวาน และยุงลายชอบออกหากินตอนกลางวัน",
    choices: [
      {
        label: "บินเข้าไปกัดที่ข้อเท้า",
        outcomes: [
          { chance: 0.6, text: "คุณดูดเลือดได้เต็มท้องโดยไม่มีใครรู้ตัว", effects: { fullness: 40 } },
          { chance: 0.4, text: "ฝ่ามือตบลงมาเฉียดตัวคุณไปนิดเดียว", effects: { health: -20, fullness: 10, cause: "human" } },
        ],
      },
      { label: "ดูดน้ำหวานจากดอกไม้แทน", outcomes: [{ chance: 1, text: "ปลอดภัยกว่า แต่ยังไม่มีโปรตีนพอสร้างไข่", effects: { fullness: 15 } }] },
    ],
  }),
  sig("Oecophylla smaragdina", "weaver_ant_silk", {
    stageTags: ADULT,
    requires: { flags: ["role_worker"] },
    text: "รังใบไม้ของอาณาจักรเริ่มคับแคบ ต้องเย็บใบไม้ทำรังใหม่",
    fact: "มดแดงเย็บใบไม้เป็นรังด้วยใยไหมจากตัวอ่อน มดงานถือตัวอ่อนไว้ในปากแล้วใช้เป็นกระสวยร้อยใบไม้เข้าหากัน",
    choices: [
      { label: "ต่อตัวเป็นสะพานดึงใบไม้เข้าหากัน", outcomes: [{ chance: 1, text: "มดงานหลายสิบตัวเกาะกันเป็นโซ่ ดึงขอบใบไม้มาชนกันได้สำเร็จ", effects: { fullness: -10, offspringCount: 10 } }] },
      { label: "ถือตัวอ่อนเย็บใบไม้", outcomes: [{ chance: 1, text: "คุณบีบตัวอ่อนเบาๆ ให้ปล่อยใยไหม ร้อยใบไม้ไปมาจนแน่น", effects: { fullness: -5, offspringCount: 8 } }] },
    ],
  }),
  sig("Apis cerana", "honeybee_heat_ball", {
    stageTags: ADULT,
    requires: { flags: ["role_worker"] },
    text: "ต่อหัวเสือตัวใหญ่บินเข้ามาที่ปากรัง จับผึ้งงานไปกินทีละตัว",
    fact: "ผึ้งโพรงรุมล้อมต่อที่บุกรังจนเป็นก้อนกลม แล้วสั่นกล้ามเนื้อจนความร้อนสูงพอจะทำให้ต่อตาย แต่ผึ้งยังทนได้",
    choices: [
      {
        label: "ร่วมรุมล้อมเป็นก้อนผึ้ง",
        outcomes: [
          { chance: 0.8, text: "ความร้อนในก้อนผึ้งฆ่าต่อได้ รังปลอดภัย", effects: { safety: 15, offspringCount: 5 } },
          { chance: 0.2, text: "คุณอยู่ใกล้ต่อเกินไป ถูกกัดก่อนที่ต่อจะตาย", effects: { health: -30, cause: "predator" } },
        ],
      },
      { label: "ออกไปหาน้ำหวานต่อ", outcomes: [{ chance: 1, text: "พี่น้องตัวอื่นจัดการต่อแทน คุณนำน้ำหวานกลับมาเติมรัง", effects: { fullness: 15, offspringCount: 3 } }] },
    ],
  }),
  sig("Vespa affinis", "hornet_sting", {
    stageTags: ADULT,
    text: "คนกลุ่มหนึ่งถือคบไฟเข้ามาใกล้รังของอาณาจักร",
    fact: "ต่อหัวเสือต่อยได้หลายครั้ง เพราะเหล็กในไม่มีเงี่ยงเหมือนผึ้ง และรังของต่อหัวเสือหนึ่งรังอาจมีต่อนับพันตัว",
    choices: [
      {
        label: "บินออกไปรุมต่อย",
        outcomes: [
          { chance: 0.6, text: "พวกเขาวิ่งหนีกระเจิง รังยังอยู่ครบ", effects: { safety: 10 } },
          { chance: 0.4, text: "ควันไฟทำให้คุณมึนงงและร่วงลงพื้น", effects: { health: -30, cause: "human" } },
        ],
      },
      { label: "ซ่อนอยู่ในรัง", outcomes: [{ chance: 1, text: "ควันลอยผ่านไป แต่ตัวอ่อนในรังบางส่วนถูกเอาไป", effects: { safety: -10 } }] },
    ],
  }),
  sig("Orthetrum sabina", "dragonfly_ambush", {
    stageTags: ADULT,
    text: "ฝูงยุงบินวนอยู่เหนือผิวน้ำในบ่อ",
    fact: "แมลงปอคาดเดาทิศทางของเหยื่อแล้วบินตัดหน้าไปดักจับกลางอากาศ งานวิจัยบางชิ้นพบว่าแมลงปอบางชนิดจับเหยื่อได้สำเร็จกว่า 90%",
    choices: [
      { label: "บินตัดหน้าดักจับ", outcomes: [{ chance: 1, text: "คุณจับยุงได้ทีละตัวด้วยขาที่ทำเป็นตะกร้า", effects: { fullness: 30 } }] },
      {
        label: "ไล่ตามแมลงปอตัวเล็กกว่า",
        outcomes: [
          { chance: 0.6, text: "คุณจับมันได้กลางอากาศ", effects: { fullness: 30 } },
          { chance: 0.4, text: "นกจาบคาโฉบมาระหว่างที่คุณกำลังไล่", effects: { health: -30, cause: "predator" } },
        ],
      },
    ],
  }),
  sig("Musca domestica", "housefly_taste", {
    stageTags: ADULT,
    text: "คุณลงเกาะบนจานข้าวที่ตั้งทิ้งไว้บนโต๊ะ",
    fact: "แมลงวันบ้านรับรสได้ด้วยขน ทำให้รู้รสอาหารตั้งแต่เท้าแตะ และกินได้เฉพาะอาหารเหลว จึงต้องพ่นน้ำย่อยลงบนอาหารแข็งให้ละลายก่อน",
    choices: [
      { label: "พ่นน้ำย่อยแล้วดูดกิน", outcomes: [{ chance: 1, text: "อาหารละลายกลายเป็นของเหลว คุณดูดกินจนอิ่ม", effects: { fullness: 30 } }] },
      {
        label: "บินไปหาจานที่ไม่มีคนอยู่",
        outcomes: [
          { chance: 0.6, text: "คุณเจอเศษอาหารในถังขยะ อาหารไม่จำกัด", effects: { fullness: 30 } },
          { chance: 0.4, text: "ไม้ตีแมลงวันฟาดลงมา", effects: { health: -25, cause: "human" } },
        ],
      },
    ],
  }),
  sig("Gryllus bimaculatus", "cricket_song", {
    stageTags: ADULT,
    text: "กลางคืนในทุ่งหญ้า จิ้งหรีดตัวผู้ทุกตัวกำลังร้องเรียกตัวเมีย",
    fact: "จิ้งหรีดร้องด้วยการถูปีกคู่หน้าเข้าหากัน ไม่ได้ใช้ปาก และได้ยินเสียงผ่านหูที่อยู่บนขาคู่หน้า",
    choices: [
      { label: "ถูปีกร้องให้ดังที่สุด", outcomes: [{ chance: 1, text: "ตัวเมียเดินตามเสียงมาหาคุณ แต่คนที่หาจับจิ้งหรีดก็ได้ยินเหมือนกัน คุณมุดรูหนีทัน", effects: { addFlags: ["has_mate"], safety: -10 } }] },
      { label: "เงียบแล้วรอดักตัวเมียที่ผ่านมา", outcomes: [{ chance: 1, text: "ตัวเมียบางตัวเดินผ่านมาหาตัวที่ร้องข้างๆ คุณ คุณได้พบมันก่อน", effects: { safety: 5 } }] },
    ],
  }),
  sig("Patanga succincta", "locust_swarm", {
    stageTags: ADULT,
    text: "ตั๊กแตนรอบตัวคุณมีมากขึ้นทุกวัน จนแทบเบียดกันทุกใบหญ้า",
    fact: "ตั๊กแตนบางชนิดเปลี่ยนนิสัยเมื่ออยู่กันแออัด จากที่ชอบอยู่ตัวเดียวกลายเป็นรวมฝูงบินไปพร้อมกันเป็นจำนวนมหาศาล",
    choices: [
      { label: "บินไปพร้อมฝูงใหญ่", outcomes: [{ chance: 1, text: "ฝูงตั๊กแตนบินไปไกลหลายสิบกิโลเมตร ลงกินไร่ข้าวโพดจนเกลี้ยง", effects: { fullness: 30, move: "far" } }] },
      { label: "อยู่ที่ทุ่งหญ้าเดิม", outcomes: [{ chance: 1, text: "หญ้าถูกกินจนเหลือน้อย คุณต้องหากินหนักขึ้น", effects: { fullness: -10 } }] },
    ],
  }),
  // ---------- แมงและตะขาบ ----------
  sig("Heterometrus laoticus", "scorpion_glow", {
    text: "คืนนี้มีคนถือไฟฉายแปลกๆ สีม่วงเดินส่องหาอะไรบางอย่างในป่า",
    fact: "แมงป่องเรืองแสงสีฟ้าอมเขียวเมื่อโดนแสงอัลตราไวโอเลต นักวิจัยจึงใช้ไฟฉายแสงยูวีออกสำรวจแมงป่องตอนกลางคืน",
    choices: [
      {
        label: "หลบลงรู",
        outcomes: [
          { chance: 0.7, text: "คุณหายลงรูก่อนแสงส่องถึง", effects: { safety: 5 } },
          { chance: 0.3, text: "ตัวคุณเรืองแสงชัดจนเขาเห็น เขาถ่ายรูปแล้วปล่อยคุณไป", effects: { safety: -5 } },
        ],
      },
      { label: "ยกก้ามขู่", outcomes: [{ chance: 1, text: "เขาถอยออกไปถ่ายรูปห่างๆ คุณกลับไปล่าจิ้งหรีดต่อ", effects: { fullness: 15 } }] },
    ],
  }),
  sig("Scolopendra subspinipes", "centipede_forcipules", {
    stageTags: ADULT,
    text: "คุณเจอลูกหนูตัวเล็กในซอกหิน",
    fact: "ตะขาบไม่ได้กัดด้วยปาก แต่ใช้ขาคู่แรกที่ดัดแปลงเป็นเขี้ยวพิษหนีบเหยื่อ ตะขาบยักษ์ล่าได้ทั้งกิ้งก่า กบ และหนูตัวเล็ก",
    choices: [
      {
        label: "หนีบด้วยเขี้ยวพิษ",
        outcomes: [
          { chance: 0.7, text: "พิษทำให้เหยื่ออ่อนแรงอย่างรวดเร็ว", effects: { fullness: 35 } },
          { chance: 0.3, text: "แม่หนูกลับมาพอดี และกัดคุณขาดไปสองข้อ", effects: { health: -20, cause: "accident" } },
        ],
      },
      { label: "หาแมลงสาบกินแทน", outcomes: [{ chance: 1, text: "แมลงสาบไม่ต่อสู้กลับ", effects: { fullness: 20 } }] },
    ],
  }),
  sig("Nephila pilipes", "golden_orb_web", {
    stageTags: ADULT,
    text: "ใยขนาดใหญ่ของคุณขาดไปครึ่งหนึ่งเพราะนกบินชน",
    fact: "ใยของแมงมุมทองยักษ์สะท้อนแสงเป็นสีเหลืองทอง และเหนียวแข็งแรงมาก ตัวผู้ตัวเล็กกว่าตัวเมียหลายเท่า",
    choices: [
      { label: "กินใยเก่าแล้วชักใยใหม่", outcomes: [{ chance: 1, text: "คุณรีไซเคิลโปรตีนจากใยเก่ามาสร้างใยใหม่ได้ทั้งผืน", effects: { fullness: -5, safety: 5 } }] },
      { label: "ซ่อมแค่ส่วนที่ขาด", outcomes: [{ chance: 1, text: "ใยครึ่งผืนจับแมลงได้น้อยลง", effects: { fullness: -10 } }] },
    ],
  }),
  // ---------- สัตว์น้ำ ----------
  sig("Portunus pelagicus", "crab_swim", {
    text: "ปลากระเบนว่ายผ่านมาเหนือพื้นทรายที่คุณฝังตัวอยู่",
    fact: "ปูม้ามีขาคู่สุดท้ายแบนเป็นใบพาย จึงว่ายน้ำได้เก่งต่างจากปูทั่วไป และชอบฝังตัวในทรายเหลือแต่ตา",
    choices: [
      { label: "ฝังตัวอยู่นิ่งๆ", outcomes: [{ chance: 1, text: "ปลากระเบนว่ายผ่านไปโดยไม่เห็นคุณ", effects: { safety: 10 } }] },
      {
        label: "ว่ายหนีด้วยขาใบพาย",
        outcomes: [
          { chance: 0.7, text: "คุณว่ายพ้นไปได้ไกล", effects: { fullness: -5 } },
          { chance: 0.3, text: "คุณว่ายเข้าไปในลอบดักปูของชาวประมง", effects: { health: -25, cause: "human" } },
        ],
      },
    ],
  }),
  sig("Penaeus monodon", "tiger_prawn_molt", {
    text: "เปลือกของคุณคับจนถึงเวลาลอกคราบ",
    fact: "กุ้งต้องลอกคราบจึงจะโตได้ ช่วงเพิ่งลอกคราบเปลือกใหม่ยังนิ่ม จึงต้องหลบซ่อนจนเปลือกแข็ง",
    choices: [
      { label: "หลบในรากโกงกางก่อนลอกคราบ", outcomes: [{ chance: 1, text: "คุณลอกคราบอย่างปลอดภัย ตัวใหญ่ขึ้นอีกขั้น", effects: { health: 10, fullness: -10 } }] },
      {
        label: "ลอกคราบตรงนี้เลย",
        outcomes: [
          { chance: 0.5, text: "ทุกอย่างเรียบร้อย", effects: { health: 10 } },
          { chance: 0.5, text: "ปลาเห็นตัวนิ่มๆ ของคุณ", effects: { health: -30, cause: "predator" } },
        ],
      },
    ],
  }),
  sig("Euphausia superba", "krill_shrink", {
    text: "น้ำแข็งทะเลปีนี้น้อย สาหร่ายใต้น้ำแข็งที่เป็นอาหารของคุณหายไปมาก",
    fact: "เคยแอนตาร์กติกลอกคราบแล้วหดตัวให้เล็กลงได้เมื่ออาหารขาดแคลน และอยู่ได้หลายเดือนโดยแทบไม่ได้กินอะไร",
    choices: [
      { label: "ลอกคราบหดตัวให้เล็กลง", outcomes: [{ chance: 1, text: "ตัวเล็กลงแต่ใช้พลังงานน้อยลงมาก คุณรอดผ่านช่วงขาดแคลน", effects: { fullness: 15, health: -5 } }] },
      { label: "ว่ายตามฝูงไปหาอาหาร", outcomes: [{ chance: 1, text: "ฝูงเคยมหาศาลว่ายไปพร้อมกัน แต่วาฬก็ตามมาด้วย", effects: { fullness: 10, safety: -10 } }] },
    ],
  }),
  sig("Hapalochlaena lunulata", "blue_ring_flash", {
    text: "ปลาตัวใหญ่ว่ายเข้ามาจ้องคุณในแอ่งหินตอนน้ำลง",
    fact: "หมึกสายวงน้ำเงินมีพิษเทโทรโดท็อกซินที่ร้ายแรงพอจะทำให้คนเสียชีวิตได้ วงสีฟ้าบนตัวสว่างวาบเป็นสัญญาณเตือนเมื่อถูกรบกวน",
    choices: [
      { label: "ทำให้วงสีฟ้าสว่างวาบ", outcomes: [{ chance: 1, text: "ปลารู้ว่าคุณอันตรายและว่ายหนีไป", effects: { safety: 15 } }] },
      { label: "พ่นน้ำแล้วหลบเข้าซอกหิน", outcomes: [{ chance: 1, text: "คุณบีบตัวเข้าซอกเล็กๆ ได้ทั้งตัว", effects: { safety: 5, fullness: -5 } }] },
    ],
  }),
  sig("Octopus cyanea", "day_octopus_camouflage", {
    text: "คุณออกหากินกลางวันบนแนวปะการัง ฉลามครีบดำว่ายวนอยู่ใกล้ๆ",
    fact: "หมึกยักษ์กลางวันเปลี่ยนสีและลวดลายผิวได้ในเสี้ยววินาทีเพื่อพรางตัว และมักออกหากินตอนกลางวันต่างจากหมึกยักษ์ส่วนใหญ่",
    choices: [
      { label: "เปลี่ยนสีให้เหมือนปะการัง", outcomes: [{ chance: 1, text: "ฉลามว่ายผ่านไปโดยไม่เห็นคุณเลย", effects: { safety: 10 } }] },
      { label: "พ่นหมึกแล้วพุ่งหนี", outcomes: [{ chance: 1, text: "กลุ่มหมึกสีดำบังตาฉลาม คุณหนีไปได้แต่เสียพลังงานมาก", effects: { fullness: -15 } }] },
    ],
  }),
  sig("Uroteuthis duvaucelii", "squid_light", {
    text: "กลางคืนในอ่าวไทย มีแสงไฟสว่างจ้าส่องลงมาจากเรือหลายลำ",
    fact: "หมึกกล้วยว่ายเข้าหาแสงไฟ ชาวประมงไทยจึงใช้เรือปั่นไฟล่อหมึกตอนกลางคืน แสงไฟจากเรือประมงหมึกเห็นได้จากอวกาศ",
    choices: [
      {
        label: "ว่ายเข้าหาแสงไฟ",
        outcomes: [
          { chance: 0.4, text: "แพลงก์ตอนรวมกันใต้แสงไฟ คุณกินได้เต็มที่", effects: { fullness: 30 } },
          { chance: 0.6, text: "อวนยกขึ้นมาจากข้างล่าง คุณหลุดลอดตาอวนออกมาได้หวุดหวิด", effects: { health: -25, cause: "human" } },
        ],
      },
      { label: "ดำลงไปในที่มืด", outcomes: [{ chance: 1, text: "คุณหากินปลาตัวเล็กในความมืดอย่างปลอดภัย", effects: { fullness: 15 } }] },
    ],
  }),
  sig("Charonia tritonis", "triton_vs_cots", {
    stageTags: ADULT,
    text: "คุณได้กลิ่นดาวมงกุฎหนามที่กำลังกินปะการังอยู่ไม่ไกล",
    fact: "หอยสังข์แตรเป็นหนึ่งในนักล่าไม่กี่ชนิดของดาวมงกุฎหนาม แต่ถูกเก็บไปขายเปลือกจนจำนวนลดลงมาก",
    choices: [
      { label: "คลานเข้าไปกิน", outcomes: [{ chance: 1, text: "คุณใช้น้ำลายที่มีกรดเจาะผ่านหนามแข็ง ได้อาหารมื้อใหญ่", effects: { fullness: 35 } }] },
      { label: "ซ่อนตัวใต้หิน", outcomes: [{ chance: 1, text: "นักดำน้ำเก็บเปลือกหอยว่ายผ่านไปโดยไม่เห็นคุณ", effects: { safety: 10 } }] },
    ],
  }),
  sig("Acanthaster planci", "cots_stomach", {
    stageTags: ADULT,
    text: "ปะการังเขากวางผืนใหญ่อยู่ตรงหน้า",
    fact: "ดาวมงกุฎหนามยื่นกระเพาะออกนอกปากไปคลุมปะการังแล้วย่อยกินเนื้อเยื่อ เหลือไว้แต่โครงหินปูนสีขาว เมื่อระบาดหนักทำให้แนวปะการังเสียหายมาก",
    choices: [
      { label: "ยื่นกระเพาะคลุมปะการัง", outcomes: [{ chance: 1, text: "คุณกินปะการังจนเหลือแต่โครงสีขาว", effects: { fullness: 35 } }] },
      { label: "ซ่อนตัวในซอกปะการังตอนกลางวัน", outcomes: [{ chance: 1, text: "นักดำน้ำที่ตามเก็บดาวมงกุฎหนามหาคุณไม่เจอ", effects: { safety: 10, fullness: -5 } }] },
    ],
  }),
  sig("Diadema setosum", "urchin_shadow", {
    text: "เงาดำๆ ทอดผ่านตัวคุณบนพื้นทราย",
    fact: "เม่นทะเลหนามดำไม่มีตา แต่ผิวทั้งตัวไวต่อแสง เมื่อมีเงาผ่านจะหันหนามยาวแหลมไปทางนั้นทันที",
    choices: [
      { label: "หันหนามไปทางเงา", outcomes: [{ chance: 1, text: "ปลาวัวที่ว่ายมาเจอหนามแหลมเต็มหน้า จึงถอยไป", effects: { safety: 10 } }] },
      { label: "คลานเข้าซอกหิน", outcomes: [{ chance: 1, text: "คุณซ่อนตัวรอจนกลางคืนค่อยออกมาแทะสาหร่าย", effects: { fullness: 15 } }] },
    ],
  }),
  sig("Acropora muricata", "coral_bleaching", {
    stageTags: ADULT,
    text: "น้ำทะเลร้อนขึ้นผิดปกติติดต่อกันหลายสัปดาห์ เนื้อเยื่อของคุณเริ่มซีดจาง",
    fact: "ปะการังได้อาหารส่วนใหญ่จากสาหร่ายเซลล์เดียวที่อาศัยในเนื้อเยื่อ เมื่อน้ำร้อนเกินไปสาหร่ายจะออกไป ปะการังจึงขาวซีดที่เรียกว่าปะการังฟอกขาว",
    choices: [
      { label: "ยืดหนวดจับแพลงก์ตอนกินเอง", outcomes: [{ chance: 1, text: "พอประทังได้จนน้ำเย็นลงและสาหร่ายกลับมา", effects: { fullness: 10, health: -10 } }] },
      { label: "รอให้น้ำเย็นลง", outcomes: [{ chance: 1, text: "หลายสัปดาห์ผ่านไปโดยไม่มีอาหาร คุณอ่อนแอลงมาก", effects: { fullness: -25, health: -15, cause: "disaster" } }] },
    ],
  }),
  sig("Chironex indrasaksajiae", "box_jelly_eyes", {
    text: "คุณว่ายเข้าหาชายหาดตอนพลบค่ำ มีตาข่ายกั้นแมงกะพรุนขึงอยู่ข้างหน้า",
    fact: "แมงกะพรุนกล่องมีตาหลายกลุ่มและว่ายน้ำได้อย่างมีทิศทาง ต่างจากแมงกะพรุนส่วนใหญ่ที่ลอยไปตามกระแสน้ำ บางชายหาดในไทยจึงขึงตาข่ายกันแมงกะพรุน",
    choices: [
      { label: "ว่ายหลบตาข่าย", outcomes: [{ chance: 1, text: "ตาของคุณมองเห็นตาข่าย คุณว่ายเลี่ยงไปหากินลูกปลาที่อื่น", effects: { fullness: 20 } }] },
      {
        label: "ว่ายตามฝูงลูกปลาเข้าไปใกล้ฝั่ง",
        outcomes: [
          { chance: 0.5, text: "คุณจับลูกปลาได้หลายตัวด้วยหนวดพิษ", effects: { fullness: 30 } },
          { chance: 0.5, text: "คลื่นซัดคุณเกยหาด", effects: { health: -35, cause: "accident" } },
        ],
      },
    ],
  }),
  // ---------- หอยทาก ไส้เดือน ----------
  sig("Lissachatina fulica", "giant_snail_invader", {
    text: "ฝนตก ใบผักในสวนชาวบ้านอวบน้ำน่ากิน",
    fact: "หอยทากยักษ์แอฟริกาเป็นหนึ่งในชนิดพันธุ์รุกรานที่ร้ายแรงที่สุดในโลก มีทั้งสองเพศในตัวเดียว และวางไข่ได้หลายร้อยฟองต่อครั้ง",
    choices: [
      {
        label: "คลานเข้าไปกินผัก",
        outcomes: [
          { chance: 0.6, text: "ผักกาดอ่อนทั้งแปลงเป็นของคุณ", effects: { fullness: 35 } },
          { chance: 0.4, text: "ชาวบ้านโรยเกลือรอบแปลงผัก", effects: { health: -25, cause: "human" } },
        ],
      },
      { label: "กินใบไม้แห้งใต้ต้นไม้", outcomes: [{ chance: 1, text: "ไม่อร่อยเท่า แต่ปลอดภัย", effects: { fullness: 15 } }] },
    ],
  }),
  sig("Pomacea canaliculata", "apple_snail_pink_eggs", {
    stageTags: ADULT,
    text: "ถึงเวลาวางไข่ แต่ไข่ของคุณจะจมน้ำตายถ้าวางไว้ใต้น้ำ",
    fact: "หอยเชอรี่วางไข่สีชมพูสดไว้เหนือน้ำบนต้นข้าว เสา และกอหญ้า สีสดเตือนนักล่าว่าไข่มีพิษ หอยเชอรี่ถูกนำเข้ามาเลี้ยงแล้วกลายเป็นศัตรูข้าวสำคัญ",
    choices: [
      { label: "ปีนต้นข้าวขึ้นไปวางไข่", outcomes: [{ chance: 1, text: "ไข่สีชมพูเกาะเป็นพวงอยู่บนต้นข้าว", effects: { fullness: -15, offspring: "clutch" } }] },
      {
        label: "ปีนเสาไม้ริมคลองแทน",
        outcomes: [
          { chance: 0.7, text: "ไข่ของคุณติดอยู่บนเสาอย่างปลอดภัย", effects: { fullness: -15, offspring: "clutch" } },
          { chance: 0.3, text: "นกปากห่างเห็นคุณระหว่างปีน", effects: { health: -30, cause: "predator" } },
        ],
      },
    ],
  }),
  sig("Lumbricus terrestris", "earthworm_rain", {
    text: "ฝนตกหนักจนน้ำซึมลงมาท่วมโพรงของคุณ",
    fact: "ไส้เดือนหายใจทางผิวหนัง และมักขึ้นมาบนผิวดินเมื่อฝนตกหนัก ไส้เดือนยังช่วยพรวนดินและเปลี่ยนใบไม้ร่วงเป็นปุ๋ยให้ต้นไม้",
    choices: [
      {
        label: "ขึ้นไปบนผิวดิน",
        outcomes: [
          { chance: 0.6, text: "อากาศบนผิวดินหายใจสบาย คุณเลื้อยไปหาที่ดินใหม่", effects: { safety: -5, move: "near" } },
          { chance: 0.4, text: "นกโรบินรออยู่บนสนามหญ้า", effects: { health: -30, cause: "predator" } },
        ],
      },
      { label: "ขุดลึกลงไปอีก", outcomes: [{ chance: 1, text: "ดินชั้นล่างแน่นกว่า น้ำยังไม่ลงมาถึง", effects: { fullness: -10 } }] },
    ],
  }),
];
